import { render, staticRenderFns } from "./selectBox.vue?vue&type=template&id=492cc5ba&"
import script from "./selectBox.vue?vue&type=script&lang=js&"
export * from "./selectBox.vue?vue&type=script&lang=js&"
import style0 from "./selectBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports